<template>
  <div class="search-grid mt20">

    <!-- Search details -->
    <div class="search-grid-article">
      <span class="search-grid-article-text" v-if="search.length">
        {{ $t('Search results for query') }}
        <strong> «{{ search }}» </strong>
      </span>
    </div>
    <!---->

    <!-- Header -->
    <div class="search-grid-header" v-if="search.length && !minLengthSearch">
      <div class="search-grid-header-about">
        <span class="search-grid-header-about-subtitle"> {{ total }} {{ $t('products') }} </span>
      </div>
      <sort-products />
    </div>
    <!---->

    <!-- Search results list -->
    <div class="search-grid-list" v-if="visibleProducts.length && search.length && !minLengthSearch">
      <product-tile v-for="product in visibleProducts"
                    :key="product.entity_id"
                    :product="product"
                    class="search-grid-list-item"
      />
    </div>
    <div class="search-grid-list" v-else-if="(search.length && !minLengthSearch  && !noResults) || preloader">
      <product-tile-preloader v-for="item in preloaderItems" :key="item" />
    </div>
    <div class="search-grid-list" v-else-if="!search.length || !visibleProducts.length && !minLengthSearch">
      <span class="search-grid-list-text"> {{ $t('No results were found.') }} </span>
    </div>

    <!---->

    <!-- Load more button -->
    <div class="search-grid-actions">
      <button type="button"
              class="search-grid-actions-btn"
              @click="seeMore"
              v-if="OnlineOnly && visibleProducts.length >= 12 && readMore && search.length && !minLengthSearch"
      > {{ $t('Load more') }} </button>
    </div>
    <!---->

  </div>
</template>

<script>
import ProductTilePreloader from 'theme/components/theme/blocks/Home/Preloaders/ProductTilePreloader'
import ProductTile from 'theme/components/core/blocks/Shop/Product/ProductTile'
import SearchPanel from '@vue-storefront/core/compatibility/components/blocks/SearchPanel/SearchPanel'
import SortProducts from 'theme/components/core/blocks/Shop/Product/Sort/SortProducts'
import VueOfflineMixin from 'vue-offline/mixin'
import { debounce } from 'lodash'

export default {
  components: {
    ProductTile,
    ProductTilePreloader,
    SortProducts
  },
  mixins: [SearchPanel, VueOfflineMixin],
  data () {
    return {
      debounceSearch: () => {},
      selectedCategoryIds: [],
      preloaderItems: 18
    }
  },
  created () {
    this.debounceSearch = debounce(this.makeSearch, 500)
    this.$bus.$on('send-search-text-to-search-page', text => { this.search = text })
    this.$bus.$on('list-change-sort', this.onSortOrderChanged)
  },
  mounted () {
    this.$bus.$emit('change-search-text', this.$route.query.search)
    this.debounceSearch()
    this.preloader = false
  },
  watch: {
    categories () {
      this.selectedCategoryIds = []
    },
    search () {
      if (!this.minLengthSearch) {
        this.preloader = true
        this.debounceSearch()
      }
    }
  },
  computed: {
    visibleProducts () {
      const productList = this.products || []
      if (this.selectedCategoryIds.length) {
        return productList.filter(product => product.category_ids.some(categoryId => {
          const catId = parseInt(categoryId)
          return this.selectedCategoryIds.includes(catId)
        }))
      }
      return productList
    },
    minLengthSearch () {
      return this.search.length < 3
    }
  }
}
</script>

<style lang="scss" scoped>
.search-grid {
  width: 850px;

  @media only screen and (max-width: 1200px) {
    width: 654px;
  }

  @media only screen and (max-width: 991px) {
    width: 722px;
  }

  @media only screen and (max-width: 768px) {
    width: 530px;
  }

  @media only screen and (max-width: 576px) {
    width: 100%;
    padding: 0 20px;
  }

  &-article {
    margin-bottom: 30px;

    &-text {
      font-size: 18px;
    }
  }

  &-header {
    margin: 25px 0 15px 0;

    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    @media only screen and (max-width: 465px) {
      flex-direction: column;
      align-items: flex-start;
    }

    &-about {
      &-title {
        margin: 0 0 10px 0;

        color: #111;
        font-size: 18px;
        font-weight: 600;
      }

      &-subtitle {
        color: #4a4a4a;
        font-size: 14px;
        font-weight: 400;
      }
    }

    &-sort {
      display: flex;
      align-items: center;

      &-title {
        margin-right: 10px;

        color: #9b9b9b;
        font-size: 14px;
        font-weight: 400;
      }
    }
  }

  &-list {
    display: flex;
    flex-wrap: wrap;

    &-item {
      width: calc(100% / 4 - 10px);

      @media only screen and (max-width: 768px) {
        width: calc(100% / 3 - 10px);
      }

      @media only screen and (max-width: 465px) {
        width: calc(100% / 2 - 10px);
      }
    }

    &-text {
      margin: 20px auto;
      font-size: 18px;
    }
  }

  &-actions {
    width: 100%;
    margin-top: 30px;
    text-align: center;

    &-btn {
      padding: 10px 25px;

      color: #fff;
      border: none;
      background: #333;

      outline: none;
      transition: .2s;

      &:hover {
        background: #4f4f4f;
      }
    }
  }
}
</style>
